/**
 * Hook idle timeout — déconnexion automatique après 15 min sans interaction,
 * avec modal d'avertissement à 14 min (60 secondes pour réagir).
 */
import { useEffect, useRef, useState } from "react";

const IDLE_MS = 15 * 60 * 1000;
const WARN_MS = 14 * 60 * 1000;
const EVENTS = ["mousedown", "keydown", "scroll", "touchstart"] as const;

export function useIdleTimeout(onLogout: () => void) {
  const [warning, setWarning] = useState(false);
  const timerRef = useRef<number | null>(null);
  const warnRef = useRef<number | null>(null);

  useEffect(() => {
    const reset = (): void => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      if (warnRef.current) window.clearTimeout(warnRef.current);
      setWarning(false);

      warnRef.current = window.setTimeout(() => setWarning(true), WARN_MS);
      timerRef.current = window.setTimeout(onLogout, IDLE_MS);
    };

    EVENTS.forEach((evt) => window.addEventListener(evt, reset, { passive: true }));
    reset();

    return () => {
      EVENTS.forEach((evt) => window.removeEventListener(evt, reset));
      if (timerRef.current) window.clearTimeout(timerRef.current);
      if (warnRef.current) window.clearTimeout(warnRef.current);
    };
  }, [onLogout]);

  return { warning, dismiss: () => setWarning(false) };
}
